import React from 'react';
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
var Price = props => {
  var {
    value
  } = props;
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var price = value && parseFloat(value).toFixed(2);
  return currentStoreCode === "fr" ? /*#__PURE__*/React.createElement("span", null, price, " $") : /*#__PURE__*/React.createElement("span", null, "$", price);
};
export default Price;